module.exports = __webpack_public_path__ + "assets/img/4aeeec97d64730bf875f8ca68b8e73dd.png";